/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthStrictHttpResponse } from '../../auth-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RefreshTokenRequestModel } from '../../models/refresh-token-request-model';
import { RefreshTokenResponseModel } from '../../models/refresh-token-response-model';

export interface LocalAccountRefreshTokenPost$Params {
      body?: RefreshTokenRequestModel
}

export function localAccountRefreshTokenPost(http: HttpClient, rootUrl: string, params?: LocalAccountRefreshTokenPost$Params, context?: HttpContext): Observable<AuthStrictHttpResponse<RefreshTokenResponseModel>> {
  const rb = new RequestBuilder(rootUrl, localAccountRefreshTokenPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AuthStrictHttpResponse<RefreshTokenResponseModel>;
    })
  );
}

localAccountRefreshTokenPost.PATH = '/LocalAccount/RefreshToken';
